import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation, Navigate } from 'react-router-dom';
import {
  User, Stethoscope, ShoppingBag, Activity,
  ChevronLeft, ChevronRight, LogOut
} from 'lucide-react';
import './App.css';

import Profil from './pages/Profil';
import Catalogue from './pages/Catalogue';
import Locations from './pages/Locations';
import Login from './pages/Login';
import { clientConnecte } from './data/mockData';

const Navigation = ({ isCollapsed, setIsCollapsed, onLogout }) => {
  const location = useLocation();

  const navItems = [
    { section: 'Navigation' },
    { path: '/locations', icon: Activity, label: 'Mes locations actives' },
    { path: '/catalogue', icon: ShoppingBag, label: 'Commander un matériel' },
    { path: '/profil', icon: User, label: 'Mon établissement' },
  ];

  return (
    <nav className={`navigation ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="nav-header">
        <div className="nav-brand">
          <Stethoscope className="brand-icon" />
          {!isCollapsed && <h1>RESPIDOM</h1>}
        </div>
        <button className="nav-toggle" onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>

      {!isCollapsed && (
        <div className="nav-user">
          <div className="user-avatar">
            {clientConnecte.prenom[0]}{clientConnecte.nom[0]}
          </div>
          <div className="user-info">
            <p className="user-name">{clientConnecte.prenom} {clientConnecte.nom}</p>
            <p className="user-role">{clientConnecte.raisonSociale}</p>
          </div>
        </div>
      )}

      <ul className="nav-menu">
        {navItems.map((item, index) => {
          if (item.section) {
            return !isCollapsed && (
              <li key={index} className="nav-section">{item.section}</li>
            );
          }
          const Icon = item.icon;
          const isActive = location.pathname.startsWith(item.path);
          return (
            <li key={index}>
              <NavLink
                to={item.path}
                className={`nav-link ${isActive ? 'active' : ''}`}
                title={isCollapsed ? item.label : ''}
              >
                <Icon size={20} />
                {!isCollapsed && <span>{item.label}</span>}
              </NavLink>
            </li>
          );
        })}
      </ul>

      <div className="nav-footer">
        {!isCollapsed && (
          <>
            <div className="nav-footer-actions">
              <button className="btn-icon" title="Déconnexion" onClick={onLogout}>
                <LogOut size={18} />
              </button>
            </div>
            <div className="nav-footer-info">
              <p>Espace Établissement</p>
              <strong>RESPIDOM Assistance Respiratoire</strong>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  return (
    <Router>
      <div className="app">
        <Navigation
          isCollapsed={sidebarCollapsed}
          setIsCollapsed={setSidebarCollapsed}
          onLogout={() => setIsLoggedIn(false)}
        />
        <main className={`main-content ${sidebarCollapsed ? 'sidebar-closed' : ''}`}>
          <Routes>
            <Route path="/" element={<Navigate to="/locations" replace />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/catalogue" element={<Catalogue />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="*" element={<Navigate to="/locations" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
